import { Suspense, ReactNode } from "react";
import { useRoutes } from "react-router-dom";
import routes from "~react-pages";
import styles from "@/pages/index.module.css";

function App(): ReactNode {
  return (
    <Suspense fallback={<main className={styles.background}></main>}>{useRoutes(routes)}</Suspense>
  );
}

export default App;
